import React from 'react';
import { Button, Stack } from '@mui/material';
import { ChevronLeft, ChevronRight, Send } from '@mui/icons-material';
import { STEP_CONFIG } from '../../constants';
import { getNextStep, getStepIndex } from '../../lib';
import { useDealBuilderStepNavigation } from '../../hooks';
import { useValidateAndAdvance } from '../../hooks/useValidateAndAdvance';
import { useDealBuilderContext } from '../../context/DealBuilderContext';

export const StepFooterNav = () => {
  const { viewStep, goToPrevStep } = useDealBuilderStepNavigation();
  const validateAndAdvance = useValidateAndAdvance();
  const { startNewQuote } = useDealBuilderContext();

  const stepIndex = getStepIndex(viewStep);
  const isFirstStep = stepIndex === 0;
  const isLastStep = stepIndex === STEP_CONFIG.length - 1;
  const nextStepConfig = STEP_CONFIG[getStepIndex(getNextStep(viewStep))];

  return (
    <Stack direction="row" justifyContent="space-between">
      <Button disabled={isFirstStep} startIcon={<ChevronLeft />} onClick={goToPrevStep}>
        Back
      </Button>

      {isLastStep ? (
        <Stack direction="row" gap={1}>
          <Button variant="outlined" startIcon={<Send />} onClick={() => startNewQuote()}>
            Save as Draft
          </Button>
          <Button variant="contained" endIcon={<Send />}>
            Generate & Send Quote
          </Button>
        </Stack>
      ) : (
        <Button variant="contained" endIcon={<ChevronRight />} onClick={validateAndAdvance}>
          Continue to {nextStepConfig.label}
        </Button>
      )}
    </Stack>
  );
};
